import * as THREE from 'three';
import { labelPlane } from '../materials/MaterialFactory';
import { markInteractive } from './BaseComponent';

export class ToggleSwitch extends THREE.Group {
  private lever = new THREE.Group();
  private target = 0;
  readonly key: 'K1' | 'K2';

  constructor(key: 'K1' | 'K2', input: 'A' | 'B') {
    super();
    this.key = key;
    this.name = `${key} 输入开关`;
    const base = new THREE.Mesh(
      new THREE.BoxGeometry(2.15, 0.42, 1.35),
      new THREE.MeshStandardMaterial({ color: 0x26323d, metalness: 0.45, roughness: 0.42 })
    );
    base.position.y = 0.58;
    base.castShadow = true;
    this.add(base);
    const collar = new THREE.Mesh(
      new THREE.CylinderGeometry(0.34, 0.42, 0.38, 20),
      new THREE.MeshStandardMaterial({ color: 0xaab4bc, metalness: 0.88, roughness: 0.22 })
    );
    collar.position.y = 0.96;
    this.add(collar);
    const rod = new THREE.Mesh(
      new THREE.CylinderGeometry(0.12, 0.16, 1.45, 16),
      new THREE.MeshStandardMaterial({ color: 0xd7dde1, metalness: 0.9, roughness: 0.18 })
    );
    rod.position.y = 0.68;
    const knob = new THREE.Mesh(
      new THREE.SphereGeometry(0.24, 18, 12),
      new THREE.MeshStandardMaterial({ color: 0x37c7e8, roughness: 0.35 })
    );
    knob.position.y = 1.44;
    this.lever.add(rod, knob);
    this.lever.position.y = 0.96;
    this.add(this.lever);
    const label = labelPlane([`${key} · 输入 ${input}`], 2.1, 0.5, { background: '#18232d', color: '#bcefff', accent: '#37c7e8' });
    label.rotation.x = -Math.PI / 2;
    label.position.set(0, 0.82, 1.05);
    this.add(label);
    markInteractive(this, {
      id: key, name: `${key} 输入开关`, english: 'Input Toggle Switch', model: `输入 ${input}`,
      function: '闭合时把输入节点接地；断开时由 10kΩ 电阻上拉。',
      connection: `闭合：${input}=0；断开：${input}=1。`,
      mistake: '误认为“开关断开”就是逻辑 0。',
      tip: '本电路的上拉电阻保证断开时输入不会悬空。'
    });
  }

  setClosed(closed: boolean): void {
    this.target = closed ? -0.52 : 0.52;
    this.userData.meta.model = closed ? '闭合到 GND · 逻辑 0' : '断开 · 上拉为逻辑 1';
  }

  update(delta: number): void {
    this.lever.rotation.z += (this.target - this.lever.rotation.z) * Math.min(1, delta * 12);
  }
}
